import { render, staticRenderFns } from "./DetailGudangKompack.vue?vue&type=template&id=6db61a7e&scoped=true&"
import script from "./DetailGudangKompack.vue?vue&type=script&lang=js&"
export * from "./DetailGudangKompack.vue?vue&type=script&lang=js&"
import style0 from "./DetailGudangKompack.vue?vue&type=style&index=0&id=6db61a7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db61a7e",
  null
  
)

export default component.exports